import { createFileRoute } from '@tanstack/react-router';
import { RoutePlaceholder } from './-components/RoutePlaceholder';

export const Route = createFileRoute('/profile/kyc')({
  component: () => (
    <RoutePlaceholder icon="lock" title="KYC" description="Verify your identity and address." />
  ),
});
